const actions = {
  switchPanel: (panel) => {
    return {
      type: 'PANEL',
      payload: panel,
    }
  },
}
export default actions
